<template>
  <div class="inquiry-page">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="back-btn" @click="returnToFrontPage">
        <a-icon type="left" /> 返回
      </div>
      <h3>{{ currentTitle }}</h3>
    </div>
    <div class="list-container">
      <div class="order-list">
        <div
            class="order-item"
            v-for="(item, index) in dataList"
            :key="index"
        >
          <div class="order-content">
            <div class="order-row">
              <span class="label">项目名称：</span>
              <span class="value">{{ item.monitorpointname }}</span>
            </div>
            <div class="order-row">
              <span class="label">区域：</span>
              <span class="value">{{ item.area }}</span>
            </div>
            <div class="order-row">
              <span class="label">楼层：</span>
              <span class="value">{{ item.floor }}</span>
            </div>
            <div class="order-row">
              <span class="label">单元号：</span>
              <span class="value">{{ item.unit_number }}</span>
            </div>
            <div class="order-row">
              <span class="label">单位名称：</span>
              <span class="value">{{ item.unit_name }}</span>
            </div>
            <div class="order-row">
              <span class="label">备注：</span>
              <span class="value">{{ item.remark }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getProjectResidentEnterprisesByCondition} from "A/thjlcx";

export default {
  name: "tenantCompany",
  components: {},
  data() {
    return {
      dataList:[],
    }
  },
  computed:{
    currentTitle() {
      return '入驻企业';
    }
  },
  created() {
    this.getDataList(this.$store.state.monitorpointnum)
  },
  methods:{
    getDataList(monitorpointnum){
      this.showLoading();
      getProjectResidentEnterprisesByCondition({monitorpointnum:monitorpointnum}).then(res => {
        this.hideLoading();
        if(res&&res.returncode==='0'){
          this.dataList = res.item;
        }
      })
    },
    returnToFrontPage() {
      this.$router.back();
    },
  }
}
</script>
<style scoped lang="scss">
.inquiry-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 20px;
}

/* 顶部导航 */
.header {
  background: #fff;
  padding: 15px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .back-btn {
    color: #1890ff;
    font-size: 16px;
    cursor: pointer;
    margin-right: auto;
    display: flex;
    align-items: center;
  }

  h3 {
    margin: 0;
    font-weight: 600;
    color: #333;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
  }
}
/* 列表容器 */
.list-container {
  background: #fff;
  margin: 10px;
  padding: 16px;
  border-radius: 8px;

  .list-header {
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 16px;
  }
}

/* 工单列表项 */
.order-list {
  .order-item {
    padding: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    margin-bottom: 12px;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .order-content {
      .order-row {
        display: flex;
        margin-bottom: 4px;
        font-size: 14px;

        .label {
          color: #999;
          min-width: 80px;
        }

        .value {
          flex: 1;
          color: #333;
        }
      }
    }

    .order-status {
      position: absolute;
      right: 12px;
      top: 12px;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 500;

      &.status-waiting { background: #fffbe6; color: #faad14; }
      &.status-processing { background: #e6f7ff; color: #1890ff; }
      &.status-completed { background: #f6ffed; color: #52c41a; }
      &.status-warning { background: #fff2e8; color: #fa8c16; }
      &.status-reject { background: #fff2f0; color: #ff4d4f; }
      &.status-third { background: #f9f0ff; color: #722ed1; }
      &.status-plan { background: #e6f7ff; color: #13c2c2; }
      &.status-delay { background: #fffbe6; color: #faad14; }
      &.status-close { background: #f0f0f0; color: #666; }
      &.status-default { background: #f0f0f0; color: #666; }
    }
  }
}
</style>